const translations = {
  en: {
    meta: {
      title: 'Leveltry',
      description:
        'Leveltry — professional, strategic, and confidential advisory for people and companies seeking clear growth.',
      noscript: 'You need to enable JavaScript to view this site.',
    },
    skipLink: 'Skip to content',
    brandHome: 'Leveltry home',
    navAria: 'Main navigation',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    nav: [
      { label: 'Services', href: '#servicios' },
      { label: 'Methodology', href: '#metodologia' },
      { label: 'Trust', href: '#confidencialidad' },
      { label: 'Results', href: '#casos' },
      { label: 'Advisors', href: '/asesores' },
    ],
    header: {
      login: 'Sign in',
      schedule: 'Register',
    },
    search: {
      placeholder: 'Search advisors…',
      ariaLabel: 'Search advisors',
      submit: 'Search',
      title: 'Advisors',
      resultsFor: 'Results for',
      resultCount: '{count} results',
      emptyQuery: 'Type a name, specialty, or language to find advisors.',
      empty: 'No advisors matched your search.',
      loading: 'Searching advisors…',
      error: 'Could not load advisors. Please try again.',
      retry: 'Try again',
      verified: 'Verified',
      rating: 'Rating',
      viewProfile: 'View profile',
      profileEyebrow: 'Advisor',
      categories: 'Specialties',
      languages: 'Languages',
      portfolio: 'Portfolio',
      ctaTitle: 'Ready to consult?',
      ctaCopy: 'Create an account or sign in to send a private consultation.',
      ctaRegister: 'Register to consult',
      ctaLogin: 'Sign in',
      notFound: 'Advisor not found.',
      backToSearch: 'Back to search',
    },
    hero: {
      eyebrow: 'Professional advisory',
      title: 'Clear decisions to grow with confidence',
      lead:
        'Strategic, financial, and operational guidance for people and teams that need direction without noise. Simple, close, and confidential, wherever you are.',
      schedule: 'Register',
      services: 'View services',
      note:
        '* Initial sessions include diagnosis and an initial roadmap with no obligation to continue.',
    },
    heroVisual: {
      session: 'Strategy session',
      incoming1: 'We need clarity on priorities for the next quarter.',
      outgoing1: 'Let us start with margin impact and team capacity.',
      incoming2: 'Can we review scenarios before committing investment?',
      outgoing2: 'Yes. I will prepare a plan with risks, milestones, and weekly metrics.',
      weeks: 'weeks',
      areas: 'areas',
      route: 'path',
      confidential: 'Confidential',
      protected: 'NDA and protected data',
    },
    statement: {
      chips: ['Strategy', 'Finance', 'Operations', 'Talent', 'Growth'],
      title:
        'Speak with clarity, decide with data, and stay close to your goals wherever you are with private, focused advisory.',
    },
    services: {
      eyebrow: 'Services',
      title: 'With the right advisory, you do not miss the key moment',
      description:
        'Whether you are redefining quarterly priorities or preparing an expansion, we work with you as if we were in the same room: listening, questioning, and building the next step.',
      moreInfo: 'Learn more',
      highlights: [
        { title: 'Strategy', copy: 'Clear plans with priorities and metrics.' },
        { title: 'Finance', copy: 'Decisions grounded in numbers and real scenarios.' },
        { title: 'Operations', copy: 'Processes that scale without losing quality.' },
        { title: 'Talent', copy: 'Teams aligned with concrete objectives.' },
      ],
    },
    methodology: {
      eyebrow: 'Methodology',
      titleLead: 'Express yourself',
      titleAccent: ' with freedom',
      description:
        'At Leveltry, every strategic conversation is protected by confidentiality agreements and clear processes. Only you and your advisor define the direction; no one else accesses sensitive business information.',
      moreInfo: 'Learn more',
      steps: [
        { label: 'Diagnosis', detail: 'We understand context, risks, and opportunities.' },
        { label: 'Roadmap', detail: 'We define priorities with achievable timelines.' },
        { label: 'Execution', detail: 'We support every critical decision.' },
        { label: 'Measurement', detail: 'We adjust with data, not assumptions.' },
      ],
    },
    confidentiality: {
      eyebrow: 'Trust',
      title: 'A secure platform to speak with confidence',
      description:
        'Sign in privately, explore verified advisor profiles, and send consultations knowing your conversations stay between you and your advisor.',
      highlights: [
        {
          title: 'Private access',
          copy: 'Secure sign-in and a space designed for confidential advisory.',
        },
        {
          title: 'Verified profiles',
          copy: 'Ratings, specialties, and portfolios so you choose with clarity.',
        },
      ],
      screens: [
        {
          id: 'login',
          label: 'Sign in',
          caption: 'Log in securely and pick up where you left off.',
        },
        {
          id: 'profile',
          label: 'Advisor profile',
          caption: 'Review experience, rating, and send your consultation.',
        },
      ],
    },
    cases: {
      eyebrow: 'Results',
      titleLead: 'Real advisory,',
      titleAccent: ' visible in the app',
      description:
        'Browse available advisors, follow open consultations, and track every answer in your activity feed.',
      highlights: [
        {
          title: 'Advisor marketplace',
          copy: 'Find experts by specialty and view their public consultation pool.',
        },
        {
          title: 'Your activity',
          copy: 'See sent consultations, responses, and progress in one place.',
        },
      ],
      screens: [
        {
          id: 'advisors',
          label: 'Available advisors',
          caption: 'Explore profiles and open consultation requests.',
        },
        {
          id: 'activity',
          label: 'Your activity',
          caption: 'Track consultations sent and answers received.',
        },
      ],
    },
    companies: {
      eyebrow: 'For companies',
      title: 'Transform your operation with advisory at scale',
      description:
        'Leveltry Business helps you align leadership, finance, and execution in one program. Prioritize investments, accelerate decisions, and build trust with your team and customers.',
      cta: 'Talk to an advisor',
      stats: [
        { value: '48 h', label: 'for initial diagnosis' },
        { value: '360°', label: 'strategic view' },
        { value: '1:1', label: 'senior support' },
      ],
    },
    contact: {
      eyebrow: 'Contact',
      title: 'Start with a confidential conversation',
      description:
        'Tell us your context and we will propose the advisory format that best fits your stage.',
      name: 'Name',
      namePlaceholder: 'Your name',
      email: 'Email',
      emailPlaceholder: 'you@email.com',
      message: 'What do you need advisory for?',
      messagePlaceholder: 'Briefly describe your situation or goal.',
      submit: 'Request advisory',
      sending: 'Sending…',
      success: 'Thank you. We received your message and will reply soon.',
      errorGeneric: 'Could not send your message. Please try again.',
    },
    footer: {
      schedule: 'Book advisory session',
      columns: [
        {
          title: 'Who we are',
          links: [
            { label: 'About Leveltry', href: '/acerca' },
            { label: 'Privacy', href: '/privacidad' },
            { label: 'Terms and conditions', href: '/terminos' },
          ],
        },
        {
          title: 'Resources',
          links: [
            { label: 'Advisors', href: '/asesores' },
            { label: 'FAQ', href: '/#contacto' },
            { label: 'Contact', href: '/#contacto' },
          ],
        },
        {
          title: 'Need help?',
          links: [{ label: 'Support', href: '/#contacto' }],
        },
      ],
      copyright: '2026 © Leveltry',
      terms: 'Terms',
      privacy: 'Privacy policy',
      sitemap: 'Sitemap',
    },
    legalUi: {
      privacy: {
        eyebrow: 'Privacy',
        loading: 'Loading privacy policy...',
        error: 'Could not load the privacy policy.',
        retry: 'Try again',
        updatedAt: 'Last updated',
      },
      terms: {
        eyebrow: 'Legal',
        loading: 'Loading terms and conditions...',
        error: 'Could not load the terms and conditions.',
        retry: 'Try again',
        updatedAt: 'Last updated',
      },
    },
  },
  es: {
    meta: {
      title: 'Leveltry',
      description:
        'Leveltry — asesoría  estratégica, profesional y confidencial para personas y empresas que buscan crecer con claridad.',
      noscript: 'Necesitas habilitar JavaScript para ver este sitio.',
    },
    skipLink: 'Ir al contenido',
    brandHome: 'Leveltry inicio',
    navAria: 'Navegación principal',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    nav: [
      { label: 'Servicios', href: '#servicios' },
      { label: 'Metodología', href: '#metodologia' },
      { label: 'Confianza', href: '#confidencialidad' },
      { label: 'Resultados', href: '#casos' },
      { label: 'Asesores', href: '/asesores' },
    ],
    header: {
      login: 'Iniciar sesión',
      schedule: 'Registrarse',
    },
    search: {
      placeholder: 'Buscar asesores…',
      ariaLabel: 'Buscar asesores',
      submit: 'Buscar',
      title: 'Asesores',
      resultsFor: 'Resultados para',
      resultCount: '{count} resultados',
      emptyQuery: 'Escribe un nombre, especialidad o idioma para encontrar asesores.',
      empty: 'No encontramos asesores con esa búsqueda.',
      loading: 'Buscando asesores…',
      error: 'No se pudieron cargar los asesores. Inténtalo de nuevo.',
      retry: 'Reintentar',
      verified: 'Verificado',
      rating: 'Valoración',
      viewProfile: 'Ver perfil',
      profileEyebrow: 'Asesor',
      categories: 'Especialidades',
      languages: 'Idiomas',
      portfolio: 'Portafolio',
      ctaTitle: '¿Listo para consultar?',
      ctaCopy: 'Crea una cuenta o inicia sesión para enviar una consulta privada.',
      ctaRegister: 'Registrarse para consultar',
      ctaLogin: 'Iniciar sesión',
      notFound: 'Asesor no encontrado.',
      backToSearch: 'Volver a la búsqueda',
    },
    hero: {
      eyebrow: 'Asesoría estratégica',
      title: 'Decisiones claras para crecer con confianza',
      lead:
        'Acompañamiento estratégico, administrativo y operativo para personas y equipos que necesitan dirección sin ruido. Simple, cercano y confidencial, disponible donde estés.',
      schedule: 'Contactar',
      services: 'Ver servicios',
      note:
        '* Las primeras asesorias incluidas en un paquete inicial por registro. sin compromiso de continuidad.',
    },
    heroVisual: {
      session: 'Sesión estratégica',
      incoming1: 'Necesitamos claridad sobre prioridades del próximo trimestre.',
      outgoing1: 'Empecemos por el impacto en margen y capacidad del equipo.',
      incoming2: '¿Podemos revisar escenarios antes de comprometer inversión?',
      outgoing2: 'Sí. Preparo un plan con riesgos, hitos y métricas semanales.',
      weeks: 'semanas',
      areas: 'áreas',
      route: 'ruta',
      confidential: 'Confidencial',
      protected: 'NDA y datos protegidos',
    },
    statement: {
      chips: ['Estrategia', 'Finanzas', 'Operaciones', 'Talento', 'Crecimiento'],
      title:
        'Habla con claridad, decide con experiencia y mantente cerca de tus objetivos, estés donde estés, con asesoría privada y enfocada.',
    },
    services: {
      eyebrow: 'Servicios',
      title: 'Con la asesoría adecuada, no te pierdes el momento clave',
      description:
        'Ya sea asesoría sobre un inconveniente puntual o un proyecto a largo plazo, trabajamos contigo como si estuviéramos en la misma sala: leyendo, escuchando, cuestionando y construyendo el siguiente paso.',
      moreInfo: 'Más información',
      highlights: [
        { title: 'Estrategia', copy: 'Personal en posiciones estratégicas.' },
        { title: 'Finanzas', copy: 'Experiencia en toma de decisiones financieras.' },
        { title: 'Operaciones', copy: 'Experiencia en gestión de operaciones.' },
        { title: 'Talento', copy: 'Conecta con asesores con experiencia.' },
      ],
    },
    methodology: {
      eyebrow: 'Metodología',
      titleLead: 'Exprésate',
      titleAccent: ' con libertad',
      description:
        'En Leveltry, cada conversación estratégica es privada y se protege con acuerdos de confidencialidad. Solo tú y tu asesor definen el rumbo; nadie más accede a la información sensible de tu negocio.',
      moreInfo: 'Más información',
      steps: [
        { label: 'Diagnóstico', detail: 'Entendemos contexto, riesgos y oportunidades.' },
        { label: 'Hoja de ruta', detail: 'Definimos prioridades con plazos alcanzables.' },
        { label: 'Ejecución', detail: 'Acompañamos cada decisión crítica.' },
        { label: 'Medición', detail: 'Ajustamos con datos, no con suposiciones.' },
      ],
    },
    confidentiality: {
      eyebrow: 'Confianza',
      title: 'Una plataforma segura para hablar con libertad',
      description:
        'Inicia sesión de forma privada, explora perfiles de asesores verificados y envía consultas sabiendo que tus conversaciones quedan entre tú y tu asesor.',
      highlights: [
        {
          title: 'Acceso privado',
          copy: 'Inicio de sesión seguro y un espacio pensado para asesoría confidencial.',
        },
        {
          title: 'Perfiles verificados',
          copy: 'Valoraciones, especialidades y portafolio para elegir con claridad.',
        },
      ],
      screens: [
        {
          id: 'login',
          label: 'Inicio de sesión',
          caption: 'Entra de forma segura y continúa donde lo dejaste.',
        },
        {
          id: 'profile',
          label: 'Perfil del asesor',
          caption: 'Revisa experiencia, valoración y envía tu consulta.',
        },
      ],
    },
    cases: {
      eyebrow: 'Resultados',
      titleLead: 'Asesoría real,',
      titleAccent: ' visible en la app',
      description:
        'Explora asesores disponibles, sigue consultas abiertas y lleva el control de cada respuesta en tu actividad.',
      highlights: [
        {
          title: 'Marketplace de asesores',
          copy: 'Encuentra expertos por especialidad y revisa el pool de consultas.',
        },
        {
          title: 'Tu actividad',
          copy: 'Consultas enviadas, respuestas y avance en un solo lugar.',
        },
      ],
      screens: [
        {
          id: 'advisors',
          label: 'Asesores disponibles',
          caption: 'Explora perfiles y consultas abiertas de la comunidad.',
        },
        {
          id: 'activity',
          label: 'Tu actividad',
          caption: 'Sigue consultas enviadas y respuestas recibidas.',
        },
      ],
    },
    companies: {
      eyebrow: 'Para Asesores',
      title: 'Obtén ingresos extra con asesoría estratégica.',
      description:
        'Leveltry te ayuda a obtener ingresos extras, ayudando en proyectos, trámites, o simplemente dando tu opinión.',
      cta: 'Registrarse',
      stats: [
        { value: '100%', label: 'Confidencialidad' },
        { value: '1:1', label: 'Asesoría personalizada' },
        { value: '0', label: 'Interrupciones, en el tiempo que tú dispongas' },
      ],
    },
    contact: {
      eyebrow: 'Contacto',
      title: 'Envíanos un mensaje',
      description:
        'Cuéntanos en que podemos ayudarte.',
      name: 'Nombre',
      namePlaceholder: 'Tu nombre',
      email: 'Email',
      emailPlaceholder: 'tu@email.com',
      message: 'Deja tu mensaje',
      messagePlaceholder: 'Describe brevemente tu situación.',
      submit: 'Enviar',
      sending: 'Enviando…',
      success: 'Gracias. Recibimos tu mensaje y te responderemos pronto.',
      errorGeneric: 'No se pudo enviar el mensaje. Inténtalo de nuevo.',
    },
    footer: {
      schedule: 'Registrarse',
      columns: [
        {
          title: 'Quiénes somos',
          links: [
            { label: 'Acerca de Leveltry', href: '/acerca' },
            { label: 'Privacidad', href: '/privacidad' },
            { label: 'Términos y condiciones', href: '/terminos' },
          ],
        },
        {
          title: 'Recursos',
          links: [
            { label: 'Asesores', href: '/asesores' },
            { label: 'Preguntas frecuentes', href: '/#contacto' },
            { label: 'Contacto', href: '/#contacto' },
          ],
        },
        {
          title: '¿Necesitas ayuda?',
          links: [{ label: 'Soporte', href: '/#contacto' }],
        },
      ],
      copyright: '2026 © Leveltry',
      terms: 'Términos y condiciones',
      privacy: 'Política de privacidad',
      sitemap: 'Mapa del sitio',
    },
    legalUi: {
      privacy: {
        eyebrow: 'Privacidad',
        loading: 'Cargando política de privacidad...',
        error: 'No se pudo cargar la política de privacidad.',
        retry: 'Reintentar',
        updatedAt: 'Última actualización',
      },
      terms: {
        eyebrow: 'Legal',
        loading: 'Cargando términos y condiciones...',
        error: 'No se pudieron cargar los términos y condiciones.',
        retry: 'Reintentar',
        updatedAt: 'Última actualización',
      },
    },
  },
  pt: {
    meta: {
      title: 'Leveltry',
      description:
        'Leveltry — assessoria profissional, estratégica e confidencial para pessoas e empresas que buscam crescer com clareza.',
      noscript: 'Você precisa habilitar o JavaScript para ver este site.',
    },
    skipLink: 'Ir para o conteúdo',
    brandHome: 'Leveltry início',
    navAria: 'Navegação principal',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    nav: [
      { label: 'Serviços', href: '#servicios' },
      { label: 'Metodologia', href: '#metodologia' },
      { label: 'Confianza', href: '#confidencialidad' },
      { label: 'Resultados', href: '#casos' },
      { label: 'Asesores', href: '/asesores' },
    ],
    header: {
      login: 'Entrar',
      schedule: 'Agendar assessoria',
    },
    search: {
      placeholder: 'Buscar assessores…',
      ariaLabel: 'Buscar assessores',
      submit: 'Buscar',
      title: 'Assessores',
      resultsFor: 'Resultados para',
      resultCount: '{count} resultados',
      emptyQuery: 'Digite um nome, especialidade ou idioma para encontrar assessores.',
      empty: 'Nenhum assessor corresponde à sua busca.',
      loading: 'Buscando assessores…',
      error: 'Não foi possível carregar os assessores. Tente novamente.',
      retry: 'Tentar novamente',
      verified: 'Verificado',
      rating: 'Avaliação',
      viewProfile: 'Ver perfil',
      profileEyebrow: 'Assessor',
      categories: 'Especialidades',
      languages: 'Idiomas',
      portfolio: 'Portfólio',
      ctaTitle: 'Pronto para consultar?',
      ctaCopy: 'Crie uma conta ou entre para enviar uma consulta privada.',
      ctaRegister: 'Registrar-se para consultar',
      ctaLogin: 'Entrar',
      notFound: 'Assessor não encontrado.',
      backToSearch: 'Voltar à busca',
    },
    hero: {
      eyebrow: 'Assessoria profissional',
      title: 'Decisões claras para crescer com confiança',
      lead:
        'Acompanhamento estratégico, financeiro e operacional para pessoas e equipes que precisam de direção sem ruído. Simples, próximo e confidencial, onde você estiver.',
      schedule: 'Agendar assessoria',
      services: 'Ver serviços',
      note:
        '* As primeiras sessões incluem diagnóstico e um roteiro inicial sem compromisso de continuidade.',
    },
    heroVisual: {
      session: 'Sessão estratégica',
      incoming1: 'Precisamos de clareza sobre as prioridades do próximo trimestre.',
      outgoing1: 'Vamos começar pelo impacto na margem e na capacidade da equipe.',
      incoming2: 'Podemos revisar cenários antes de comprometer investimento?',
      outgoing2: 'Sim. Preparo um plano com riscos, marcos e métricas semanais.',
      weeks: 'semanas',
      areas: 'áreas',
      route: 'caminho',
      confidential: 'Confidencial',
      protected: 'NDA e dados protegidos',
    },
    statement: {
      chips: ['Estratégia', 'Finanças', 'Operações', 'Talento', 'Crescimento'],
      title:
        'Fale com clareza, decida com dados e mantenha-se perto dos seus objetivos, esteja onde estiver, com assessoria privada e focada.',
    },
    services: {
      eyebrow: 'Serviços',
      title: 'Com a assessoria certa, você não perde o momento-chave',
      description:
        'Seja para redefinir prioridades do trimestre ou preparar uma expansão, trabalhamos com você como se estivéssemos na mesma sala: ouvindo, questionando e construindo o próximo passo.',
      moreInfo: 'Saiba mais',
      highlights: [
        { title: 'Estratégia', copy: 'Planos claros com prioridades e métricas.' },
        { title: 'Finanças', copy: 'Decisões com números e cenários reais.' },
        { title: 'Operações', copy: 'Processos que escalam sem perder qualidade.' },
        { title: 'Talento', copy: 'Equipes alinhadas a objetivos concretos.' },
      ],
    },
    methodology: {
      eyebrow: 'Metodologia',
      titleLead: 'Expresse-se',
      titleAccent: ' com liberdade',
      description:
        'Na Leveltry, cada conversa estratégica é protegida por acordos de confidencialidade e processos claros. Só você e seu assessor definem o rumo; ninguém mais acessa informações sensíveis do seu negócio.',
      moreInfo: 'Saiba mais',
      steps: [
        { label: 'Diagnóstico', detail: 'Entendemos contexto, riscos e oportunidades.' },
        { label: 'Roteiro', detail: 'Definimos prioridades com prazos alcançáveis.' },
        { label: 'Execução', detail: 'Acompanhamos cada decisão crítica.' },
        { label: 'Medição', detail: 'Ajustamos com dados, não com suposições.' },
      ],
    },
    confidentiality: {
      eyebrow: 'Confiança',
      title: 'Uma plataforma segura para falar com liberdade',
      description:
        'Entre com privacidade, explore perfis verificados de assessores e envie consultas sabendo que suas conversas ficam entre você e seu assessor.',
      highlights: [
        {
          title: 'Acesso privado',
          copy: 'Login seguro e um espaço pensado para assessoria confidencial.',
        },
        {
          title: 'Perfis verificados',
          copy: 'Avaliações, especialidades e portfólio para escolher com clareza.',
        },
      ],
      screens: [
        {
          id: 'login',
          label: 'Entrar',
          caption: 'Acesse com segurança e continue de onde parou.',
        },
        {
          id: 'profile',
          label: 'Perfil do assessor',
          caption: 'Veja experiência, avaliação e envie sua consulta.',
        },
      ],
    },
    cases: {
      eyebrow: 'Resultados',
      titleLead: 'Assessoria real,',
      titleAccent: ' visível no app',
      description:
        'Explore assessores disponíveis, acompanhe consultas abertas e controle cada resposta na sua atividade.',
      highlights: [
        {
          title: 'Marketplace de assessores',
          copy: 'Encontre especialistas por área e veja o pool de consultas.',
        },
        {
          title: 'Sua atividade',
          copy: 'Consultas enviadas, respostas e progresso em um só lugar.',
        },
      ],
      screens: [
        {
          id: 'advisors',
          label: 'Assessores disponíveis',
          caption: 'Explore perfis e consultas abertas da comunidade.',
        },
        {
          id: 'activity',
          label: 'Sua atividade',
          caption: 'Acompanhe consultas enviadas e respostas recebidas.',
        },
      ],
    },
    companies: {
      eyebrow: 'Para empresas',
      title: 'Transforme sua operação com assessoria em escala',
      description:
        'Leveltry Business ajuda você a alinhar liderança, finanças e execução em um único programa. Priorize investimentos, acelere decisões e construa relações de confiança com sua equipe e seus clientes.',
      cta: 'Falar com um assessor',
      stats: [
        { value: '48 h', label: 'para diagnóstico inicial' },
        { value: '360°', label: 'visão estratégica' },
        { value: '1:1', label: 'acompanhamento sênior' },
      ],
    },
    contact: {
      eyebrow: 'Contato',
      title: 'Comece com uma conversa confidencial',
      description:
        'Conte seu contexto e proporemos o formato de assessoria que melhor se adapta à sua etapa.',
      name: 'Nome',
      namePlaceholder: 'Seu nome',
      email: 'E-mail',
      emailPlaceholder: 'voce@email.com',
      message: 'Em que você precisa de assessoria?',
      messagePlaceholder: 'Descreva brevemente sua situação ou objetivo.',
      submit: 'Solicitar assessoria',
      sending: 'Enviando…',
      success: 'Obrigado. Recebemos sua mensagem e responderemos em breve.',
      errorGeneric: 'Não foi possível enviar a mensagem. Tente novamente.',
    },
    footer: {
      schedule: 'Agendar assessoria',
      columns: [
        {
          title: 'Quem somos',
          links: [
            { label: 'Sobre a Leveltry', href: '/acerca' },
            { label: 'Privacidade', href: '/privacidad' },
            { label: 'Termos e condições', href: '/terminos' },
          ],
        },
        {
          title: 'Recursos',
          links: [
            { label: 'Assessores', href: '/asesores' },
            { label: 'Perguntas frequentes', href: '/#contacto' },
            { label: 'Contato', href: '/#contacto' },
          ],
        },
        {
          title: 'Precisa de ajuda?',
          links: [{ label: 'Suporte', href: '/#contacto' }],
        },
      ],
      copyright: '2026 © Leveltry',
      terms: 'Termos',
      privacy: 'Política de privacidade',
      sitemap: 'Mapa do site',
    },
    legalUi: {
      privacy: {
        eyebrow: 'Privacidade',
        loading: 'Carregando política de privacidade...',
        error: 'Não foi possível carregar a política de privacidade.',
        retry: 'Tentar novamente',
        updatedAt: 'Última atualização',
      },
      terms: {
        eyebrow: 'Legal',
        loading: 'Carregando termos e condições...',
        error: 'Não foi possível carregar os termos e condições.',
        retry: 'Tentar novamente',
        updatedAt: 'Última atualização',
      },
    },
  },
};

export function getTranslations(locale) {
  return translations[locale] || translations.en;
}
